import React from 'react';
import {Row,Col,Badge} from 'react-bootstrap';

import {  Field  } from 'formik';

import {RadioGroup, Radio} from 'react-radio-group';
import {ErrorMessage,TIPO_EVENTO} from '../../../_helpers';

export const Paso0 = ({values,state,setFieldValue,optionsSensores}) =>(
    <>
    <Row>
      <Col xs={12}>
      <h5><Badge className=" text-white">Paso <b>1</b></Badge></h5>
      </Col>
              <Col xs={12} lg={5}>
                  <label htmlFor="nombre">Nombre</label><ErrorMessage name={`nombre`} />
                  <Field name="nombre" />
              </Col>
              <Col xs={12} lg={7}>
                  <label >Tipo</label> <ErrorMessage name={`tipoEvento.id`} />
                  <RadioGroup  name="tipoEvento" selectedValue={values.tipoEvento.id}
                        onChange={(value)=> setFieldValue(`tipoEvento.id`,value)}>
                            <label className="label-check" htmlFor="Automatico">Automático</label>
                                  <Radio className="option-input checkbox"  type="checkbox" id="Automatico" value={TIPO_EVENTO.AUTOMATICO} />
  
                            <label className="label-check" htmlFor="Programado">Programado</label>
                                  <Radio className="option-input checkbox"  type="checkbox" id="Programado" value={TIPO_EVENTO.PROGRAMADO} />
  
                  </RadioGroup>
                  
              </Col>
          </Row>
    </>
  );